export enum PAYMENT_TYPES {
	storecredit = 'storeCredit',
	card = 'Card',
	cod = 'cod',
	paypal = 'paypal',
	alipay = 'alipay',
	BOPO = 'BOPO',
}
